import axios from 'axios';
import { CPO_API } from '../config';
import { handleError, handleResponse } from './reponse';

const CMS_URL = `${CPO_API}/project/cmss`;

// Cache for CMS data to prevent duplicate API calls
let cmsCache = null;
let cmsCachePromise = null;

const getCMS = async () => {
    // Return cached data if available
    if (cmsCache) {
        return cmsCache;
    }
    
    // If a request is already in progress, wait for it
    if (cmsCachePromise) {
        return cmsCachePromise;
    }
    
    // Make the API call and cache the promise
    cmsCachePromise = axios.get(CMS_URL)
        .then(handleResponse)
        .then(result => {
            cmsCache = result;
            cmsCachePromise = null;
            return result;
        })
        .catch(error => {
            cmsCachePromise = null;
            return handleError(error);
        });
    
    return cmsCachePromise;
};

const getHome = async () => {
    const result = await getCMS();
    return result.data.findLast(e => e.name === "home");
};

const getAboutUs = async () => {
    const result = await getCMS();
    return result.data.findLast(e => e.name === "aboutus");
};


const getFooterDetails = async () => {
    const result = await getCMS();
    return {
        footer: result.data.findLast(e => e.name === "footer") || null,
        contactus: result.data.findLast(e => e.name === "contactus") || null,
    };
};

export const cmsAPI  = {
    getHome,
    getAboutUs,
    getFooterDetails,
};
